/* eslint-disable camelcase */
/* eslint-disable react/sort-comp */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import HighChartGraph, { ApiHandler as HC, HighChartOptions } from 'wdna-highchart';

import { JarvisWidget } from 'wdna-components/lib';
import { initProcess, finishProcess } from 'wdna-components/lib/scheduler/actions';
import Loader from 'wdna-components/lib/loaders/local/Loader';

import { ContextType, FilterContext } from '../../../../../types';
import { mergeDataForHistogram } from '../../helpers/chart';

import pressets from '../../helpers/pressets';

type Props = unknown;

interface State {
  loading: boolean;
  options: any;
  querying: boolean;

  data: any[];
}

export default class GraphChart extends React.Component<Props, State> {
  private pid: string;
  private mounted: boolean;

  public static contextType: React.Context<ContextType> = FilterContext;
  public context: React.ContextType<typeof FilterContext> | undefined;

  public constructor(props: Props) {
    super(props);

    this.mounted = false;

    this.pid = window.getStr();

    this.state = {
      loading: false,
      options: null,
      querying: false,

      data: [],
    };
  }

  public componentDidMount(): void {
    this.mounted = true;
    const { dashboardData } = this.context?.parentState || {};
    this.setUpData(dashboardData);
  }

  // TODO: change
  // eslint-disable-next-line camelcase
  public UNSAFE_componentWillReceiveProps(nextProps: Props, nextContext: ContextType): void {
    const { update, dashboardData } = nextContext.parentState;

    if (update !== this.context?.parentState.update) {
      this.setUpData(dashboardData);
    }
  }

  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public setLocalState = (nextState: Partial<State>, callback?: (() => void)): void => {
    if (this.mounted) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...nextState,
      }), callback);
    }
  };

  public setUpData = (dashboardData: any = {}): void => {
    const data: any[] = mergeDataForHistogram(dashboardData.graphData || []);
    this.setLocalState({
      data,
      options: this.getOptions(),
    });
  };

  public getOptions = (): any => {
    const options: HighChartOptions = _.cloneDeep(pressets);

    const apiHandler: HC = new HC(options);
    apiHandler.setOption('title.text', '');
    apiHandler.setOption('subtitle.text', '');
    apiHandler.setOption('exporting.filename', 'waste_unloads');

    return options;
  };

  public mapInstance = (): void => {
    this.loadingFinish();
  };

  public loadingStart = (): void => {
    this.setLocalState({ loading: true, querying: true });
    window.store.dispatch(initProcess(this.pid));
  };

  public loadingFinish = (): void => {
    this.setLocalState({ loading: false });
    window.store.dispatch(finishProcess(this.pid));
  };

  public render(): JSX.Element {
    const { data, options, loading, querying } = this.state;
    return (
      <JarvisWidget
        custombutton={false}
        editbutton={false}
        togglebutton={false}
        colorbutton={false}
        deletebutton={false}
        fullscreenbutton={false}
      >
        <div className="widget-body" style={{ maxWidth: '95vw' }}>
          <Loader showTextStates show={loading} querying={querying} />
          {data && options && <HighChartGraph data={data} options={options} mapInstance={this.mapInstance} />}
        </div>
      </JarvisWidget>
    );
  }
}

export type GraphChartType = typeof GraphChart;
